import React from 'react'
import useTranslation from '../hooks/useTranslation'

const ConditionLayout = () => {
    const {t} = useTranslation()
  return (
    <div className="max-w-[1366px] h-full mx-auto pt-[200px] pb-[109px] px-[30px]">
        <h1 className='font-bold text-[20px] text-[#7C369A] mb-5'>
            {t("Conditions Générales d'Utilisation")}
        </h1>
        <h2 className='font-bold mb-3'>{t("En utilisant ce site, vous déclarez avoir lu et accepté toutes les conditions suivantes :")}</h2>
        <p>{t("Nous avons le droit de modifier, d’ajouter ou de supprimer toute clause du présent Contrat à tout moment sans en informer les abonnés, alors veuillez consulter les modalités avant de faire un départ.")}</p>
    </div>
  )
}

export default ConditionLayout